import { Analytics } from '@cobliteam/analytics';
import type { Preferences } from '@cobliteam/common-types';
import { useLocalStorage } from '@cobliteam/hooks';
import { useEffect, useState } from 'react';
import ReactJoyride, { type Step, type Status } from 'react-joyride';
import { SidebarCard } from './AppJoyrideCards';

// key to store if the joyride has been completed
const JOYRIDE_COMPLETED_KEY = 'appJoyride';

const steps: Step[] = [
  {
    title: 'Você está vendo a nova barra de navegação do painel da Cobli!',
    content: 'As mesmas páginas que você já conhece, com novos agrupamentos e novos ícones.',
    target: '[data-testid="sidebar"]',
    placement: 'auto' as const,
    disableBeacon: true,
    styles: {
      spotlight: {
        marginLeft: '-4px',
      },
    },
  },
  {
    title: 'Conheça o novo filtro de grupos de veículos!',
    content: 'Agora você pode filtrar mais fácil seus grupos com o novo filtro! O grupo filtrado irá refletir em todas as páginas do painel.',
    target: '#sidebar-global-filter-id',
    placement: 'auto' as const,
    disableBeacon: true,
  },
  {
    title: 'Você pode usar a versão expandida ou contraída da barra.',
    content: 'Clicando neste botão você alterna entre as duas versões.',
    target: '[data-testid="sidebar-trigger"]',
    placement: 'auto' as const,
    disableBeacon: true,
  },
  {
    title: 'Sua área pessoal em um só lugar.',
    content: 'Aqui você encontra tudo que precisar sobre a sua conta, área do cliente, configurações gerais, pedidos, treinamentos e finanças.',
    target: '[data-testid="header-user-button"]',
    placement: 'top' as const,
    disableBeacon: true,
  },
];

const AppJoyride = () => {
  const [preferences, setPreferences] = useLocalStorage<Preferences>('preferences');
  const [run, setRun] = useState(false);

  const handleJoyrideCallback = (data: { status: Status }) => {
    if (data.status === 'finished') {
      Analytics.track('Joyride - Complete');
      const newPreferences = { ...preferences, [JOYRIDE_COMPLETED_KEY]: true };
      setPreferences(newPreferences);
      setRun(false);
    } else if (data.status === 'skipped') {
      Analytics.track('Joyride - Skip');
      const newPreferences = { ...preferences, [JOYRIDE_COMPLETED_KEY]: true };
      setPreferences(newPreferences);
      setRun(false);
    }
  };

  useEffect(() => {
    if (preferences?.appJoyride === undefined || preferences?.appJoyride === false) {
      // wait sidebar to be mounted and animated finished
      setTimeout(() => {
        setRun(true);
        Analytics.track('Joyride - Start');
      }, 1000);
    }
  }, [preferences]);

  return (
    <ReactJoyride
      steps={steps}
      run={run}
      callback={handleJoyrideCallback}
      spotlightPadding={4}
      tooltipComponent={(props) => <SidebarCard {...props} />}
      styles={{
        options: {
          zIndex: 99999,
        },
      }}
    />
  );
};

export default AppJoyride;
